module.exports = __webpack_public_path__ + "img/maskare.e752ccc0.jpeg";